module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/unpaid-4874787f9ef0b9d86942216ec27e4088.png";